module.exports = __webpack_public_path__ + "img/destination_jozani_ln.c83d86ac.jpg";